import i18n from "@/i18n";
import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";


export default {
    namespaced: true,
    state: {
        payouts: [],
    },
    mutations: {
        setPayouts(state, newData) {
            state.payouts = newData;
        },
        addPayout(state, newData) {
            state.payouts.push(newData);
        },
        updatePayout(state, newData) {
            const targetPayoutIndex = state.payouts.findIndex(payout => payout.id === newData.id);
            state.payouts[targetPayoutIndex] = newData;
        },
    },
    actions: {
        async getPayouts({commit, rootState}, data) {
            const {personalData, company} = rootState;
            const {targetPeriod} = data;
            const url = `${URLS.MODEL.PAYOUT.PAYOUTS_URL}?target_period=${targetPeriod}`;
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("setPayouts", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createPayout({commit, rootState}, data) {
            const {personalData, company, schedule} = rootState;
            const {items, target_period, type, note} = data;
            const url = URLS.MODEL.PAYOUT.PAYOUTS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    items: items,
                    target_period: target_period,
                    type: type,
                    note: note,
                }),
                credentials: "include",
            };
            const successfulHandler = (data) => {
                if (data["payout_data"]["target_period"] === schedule.currentSchedulePeriod.date) {
                    commit("addPayout", data["payout_data"]);
                    commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                }
                notify(i18n.global.t("Payout successfully created"), "black", 3000);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async deletePayout({commit, rootState}, payoutId) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.PAYOUT.PAYOUT_URL.replace("<ID>", payoutId);
            const options = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("updatePayout", data["payout_data"]);
                commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                notify(i18n.global.t("Payout successfully deleted"), "black", 3000);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};